import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, of, switchMap, tap} from 'rxjs';
import {EmailversandService, ProblemDTO} from '../../openapi/fakturierung-openapi';
import {SendenDialogActions} from '../actions/senden-dialog.actions';
import {mappedHttpErrorResponseOperator} from '@adnova/jf-ng-components';
import {NGXLogger} from 'ngx-logger';


/**
 * Effects fuer den Senden-Dialog. Aktuell: Laden der Versand-Vorschau
 * (Betreff + Body), die der User vor dem eigentlichen Versand einsehen kann.
 */
@Injectable()
export class SendenDialogEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly emailversandService: EmailversandService,
    private readonly _logger: NGXLogger,
  ) {
  }

  readonly loadVorschau$ = createEffect(() => this.actions$.pipe(
    ofType(SendenDialogActions.loadVorschau),
    switchMap(({betriebId, belegId}) =>
      this.emailversandService.readVersandVorschau(betriebId, belegId).pipe(
        map(response => SendenDialogActions.loadVorschauSuccess({
          betreff: response.betreff,
          body: response.body,
        })),
        catchError(error => of(error).pipe(
          mappedHttpErrorResponseOperator<ProblemDTO>(error),
          tap(mapped => this._logger.error('load vorschau failed.', 'status:', mapped.status)),
          map(mapped => SendenDialogActions.loadVorschauFailure({error: mapped})),
        )),
      ),
    ),
  ));
}
